.notes {
  &__top {
    display: flex;
    flex-flow: column nowrap;
    gap: 15px;
    margin: 0 0 30px;
  }

  &__metadata {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  &__title {
    font: use-font-accent("700 20px/27px");
    text-transform: uppercase;
  }
}

.notes-wrapper {
  border-left: 1px solid var(--palette-background-secondary);
  display: flex;
  flex-flow: column nowrap;
  gap: 15px;
}

.rtc-wrapper {
  & > * {
    padding: 30px 15px 0;

    @include use-desktop-device {
      padding: 30px 0 0;
    }

    &:not(:first-child) {
      border-top: 1px solid var(--palette-foreground-tertiary);
      margin-top: 30px;
    }
  }
}
